import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Space, Button } from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';

interface FestivalModalProps {
  visible: boolean;
  onCancel: () => void;
  onCreate: (data: any) => void;// callback after successful create/update
  isEditMode: boolean;
  initialValues: { festival_id: number; festival_name: string; festival_status: number } | null;
}

const FestivalModal: React.FC<FestivalModalProps> = ({
  visible,
  onCancel,
  onCreate,
  isEditMode,
  initialValues,
}) => {
  const [form] = Form.useForm();
  const isSubmitDisabled = () => {
    const errors = form.getFieldsError();
    return errors.some(({ errors }) => errors.length > 0);
  };
  const [isModalClose, setIsModalClose] = useState(true);
  useEffect(() => {
    if (isEditMode && initialValues) {
      form.setFieldsValue({
        festival_name: initialValues.festival_name,
      });
    } else {
      form.resetFields();
    }
  }, [isEditMode, initialValues, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const dataVal = {
        festival_name: values.festival_name,
        ...(initialValues?.festival_id && { pi_id: initialValues.festival_id }),
      };
      const url = isEditMode ? 'edit-festival' : 'add-festival';

      const method = isEditMode ? 'put' : 'post';

      // Update existing festival
      const data = await apiRequest({
        method: method,
        url: url,
        data: dataVal,
      });

      showSuccess(
        isEditMode ? 'Festival updated successfully' : 'Festival created successfully!',
      );
      form.resetFields();

      onCreate(data); // refresh table data
      onCancel(); // close modal
    } catch (error: any) {
      if (error.errorFields) {
        // validation error, do nothing
      } else {
        showError('Failed to save festival');
        console.error(error);
      }
    }
  };

  return (
    <Modal
      open={visible}
      title={isEditMode ? 'Edit Festival' : 'Add Festival'}
      okText={isEditMode ? 'Update' : 'Create'}
      onCancel={onCancel}
      onOk={handleSubmit}
      destroyOnHidden
      footer={null}
    >
      <Form form={form}
    layout="vertical"
    name="festival_form"
    onFinish={handleSubmit}>
        <Form.Item
          label="Festival Name"
          name="festival_name"
          rules={[{ required: true, message: 'Please enter festival name' }]}
        >
          <Input showCount maxLength={255} placeholder="Enter festival name" />
        </Form.Item>
        <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            {!isEditMode && (
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => setIsModalClose(false)}
                disabled={isSubmitDisabled()}
              >
                Submit & Create New Designation
              </Button>
            )}
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => setIsModalClose(true)}
              disabled={isSubmitDisabled()}
            >
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FestivalModal;
